export const btnStyOne = {
  fontSize: "16px",
  fontFamily: "Poppins",
  fontWeight: 500,
  width: "100%",
  height: 60,
  borderRadius: 40,
  my: 1,
  backgroundColor: "#459173",
  color: "#fff",
};
export const btnApple = {
  fontSize: "15px",
  fontFamily: "Poppins",
  fontWeight: 500,
  width: "100%",
  height: 60,
  borderRadius: 40,
  my: 1,
  border: "1px solid #45917366",
  color: "#000",
};

export const btnGoogle = {
  fontSize: "15px",
  fontFamily: "Poppins",
  fontWeight: 500,
  width: "100%",
  height: 60,
  borderRadius: 40,
  my: 1,
  border: "1px solid #45917366",
  color: "#000",
};

export const line = {
  backgroundColor: "#C2CDD6", 
  height: 1.5,
  width: "47%",
};
export const lineText = {
  fontFamily: "Poppins",
  fontSize: 12,
  fontWeight: 500,
  marginHorizontal: 10,
  color: "#C6E4D8",
};
